import { createContext, useContext, useState, ReactNode } from "react";

interface SignupFormData {
  companyName: string;
  brandProfileImage?: string;
  niches: Array<{ id: string; name: string }>;
  programSettings?: {
    commissionRate: string;
    discountPercentage: string;
  };
}

interface SignupPreviewContextType {
  signupStep: number;
  formData: SignupFormData;
  setSignupStep: (step: number) => void;
  setFormData: (data: SignupFormData) => void;
}

const SignupPreviewContext = createContext<
  SignupPreviewContextType | undefined
>(undefined);

export function SignupPreviewProvider({ children }: { children: ReactNode }) {
  const [signupStep, setSignupStep] = useState<number>(1);
  const [formData, setFormData] = useState<SignupFormData>({
    companyName: "",
    niches: [],
  });

  return (
    <SignupPreviewContext.Provider
      value={{
        signupStep,
        formData,
        setSignupStep,
        setFormData,
      }}
    >
      {children}
    </SignupPreviewContext.Provider>
  );
}

export function useSignupPreview() {
  const context = useContext(SignupPreviewContext);
  if (context === undefined) {
    throw new Error(
      "useSignupPreview must be used within a SignupPreviewProvider"
    );
  }
  return context;
}

// Optional hook that doesn't throw if context is not available
export function useSignupPreviewOptional() {
  const context = useContext(SignupPreviewContext);
  return context;
}
